import { reactive, watch } from 'vue'
import type { Reactive } from 'vue'
import type { MenuItemProps } from '~/components/dashboard/MenuItem.vue'

export const useMenuItemData = <T extends MenuItemProps[]>(data: () => T): Reactive<T> => {
   const menuItemData = reactive(data()) as Reactive<T> & MenuItemProps[]

   watch(data, (newData) => {
      menuItemData.splice(0, menuItemData.length, ...newData)
   })

   return menuItemData
}
